/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreateAdminRequest } from '../api-models';
// @ts-ignore
import { LoginResponse } from '../api-models';
// @ts-ignore
import { Response } from '../api-models';
// @ts-ignore
import { SupportFacilityOption } from '../api-models';
/**
 * SupportApi - axios parameter creator
 * @export
 */
export const SupportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateAdminRequest} [createAdminRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportCreatePost: async (createAdminRequest?: CreateAdminRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Support/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAdminRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary SPD-5577: enters a facility as the built-in System user, or moves to another one. The  response is the token pair to continue with; the caller\'s current token is not changed.
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportEnterFacilityFacilityIdPost: async (facilityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('supportEnterFacilityFacilityIdPost', 'facilityId', facilityId)
            const localVarPath = `/Support/enter-facility/{facilityId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportFacilitiesGet: async (filter?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Support/facilities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportFacilityGet: async (filter?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Support/facility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary SPD-5577: the facilities a support user can enter, for the picker after sign-in and  the selector at the top of the portal.
         * @param {string} [search] Optional: part of a facility name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportFacilityOptionsGet: async (search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Support/facility-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        supportLoginFacilityIdGet: async (facilityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('supportLoginFacilityIdGet', 'facilityId', facilityId)
            const localVarPath = `/Support/login/{facilityId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupportApi - functional programming interface
 * @export
 */
export const SupportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateAdminRequest} [createAdminRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportCreatePost(createAdminRequest?: CreateAdminRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportCreatePost(createAdminRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary SPD-5577: enters a facility as the built-in System user, or moves to another one. The  response is the token pair to continue with; the caller\'s current token is not changed.
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportEnterFacilityFacilityIdPost(facilityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportEnterFacilityFacilityIdPost(facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportFacilitiesGet(filter?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportFacilitiesGet(filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportFacilityGet(filter?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportFacilityGet(filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary SPD-5577: the facilities a support user can enter, for the picker after sign-in and  the selector at the top of the portal.
         * @param {string} [search] Optional: part of a facility name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportFacilityOptionsGet(search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SupportFacilityOption>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportFacilityOptionsGet(search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async supportLoginFacilityIdGet(facilityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportLoginFacilityIdGet(facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SupportApi - factory interface
 * @export
 */
export const SupportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupportApiFp(configuration)
    return {
        /**
         * 
         * @param {SupportApiSupportCreatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportCreatePost(requestParameters: SupportApiSupportCreatePostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.supportCreatePost(requestParameters.createAdminRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary SPD-5577: enters a facility as the built-in System user, or moves to another one. The  response is the token pair to continue with; the caller\'s current token is not changed.
         * @param {SupportApiSupportEnterFacilityFacilityIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportEnterFacilityFacilityIdPost(requestParameters: SupportApiSupportEnterFacilityFacilityIdPostRequest, options?: AxiosRequestConfig): AxiosPromise<LoginResponse> {
            return localVarFp.supportEnterFacilityFacilityIdPost(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SupportApiSupportFacilitiesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportFacilitiesGet(requestParameters: SupportApiSupportFacilitiesGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.supportFacilitiesGet(requestParameters.filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SupportApiSupportFacilityGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportFacilityGet(requestParameters: SupportApiSupportFacilityGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.supportFacilityGet(requestParameters.filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary SPD-5577: the facilities a support user can enter, for the picker after sign-in and  the selector at the top of the portal.
         * @param {SupportApiSupportFacilityOptionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportFacilityOptionsGet(requestParameters: SupportApiSupportFacilityOptionsGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<SupportFacilityOption>> {
            return localVarFp.supportFacilityOptionsGet(requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SupportApiSupportLoginFacilityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        supportLoginFacilityIdGet(requestParameters: SupportApiSupportLoginFacilityIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.supportLoginFacilityIdGet(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for supportCreatePost operation in SupportApi.
 * @export
 * @interface SupportApiSupportCreatePostRequest
 */
export interface SupportApiSupportCreatePostRequest {
    /**
     * 
     * @type {CreateAdminRequest}
     * @memberof SupportApiSupportCreatePost
     */
    readonly createAdminRequest?: CreateAdminRequest
}

/**
 * Request parameters for supportEnterFacilityFacilityIdPost operation in SupportApi.
 * @export
 * @interface SupportApiSupportEnterFacilityFacilityIdPostRequest
 */
export interface SupportApiSupportEnterFacilityFacilityIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SupportApiSupportEnterFacilityFacilityIdPost
     */
    readonly facilityId: string
}

/**
 * Request parameters for supportFacilitiesGet operation in SupportApi.
 * @export
 * @interface SupportApiSupportFacilitiesGetRequest
 */
export interface SupportApiSupportFacilitiesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SupportApiSupportFacilitiesGet
     */
    readonly filter?: string
}

/**
 * Request parameters for supportFacilityGet operation in SupportApi.
 * @export
 * @interface SupportApiSupportFacilityGetRequest
 */
export interface SupportApiSupportFacilityGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SupportApiSupportFacilityGet
     */
    readonly filter?: string
}

/**
 * Request parameters for supportFacilityOptionsGet operation in SupportApi.
 * @export
 * @interface SupportApiSupportFacilityOptionsGetRequest
 */
export interface SupportApiSupportFacilityOptionsGetRequest {
    /**
     * Optional: part of a facility name.
     * @type {string}
     * @memberof SupportApiSupportFacilityOptionsGet
     */
    readonly search?: string
}

/**
 * Request parameters for supportLoginFacilityIdGet operation in SupportApi.
 * @export
 * @interface SupportApiSupportLoginFacilityIdGetRequest
 */
export interface SupportApiSupportLoginFacilityIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SupportApiSupportLoginFacilityIdGet
     */
    readonly facilityId: string
}

/**
 * SupportApi - object-oriented interface
 * @export
 * @class SupportApi
 * @extends {BaseAPI}
 */
export class SupportApi extends BaseAPI {
    /**
     * 
     * @param {SupportApiSupportCreatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public supportCreatePost(requestParameters: SupportApiSupportCreatePostRequest = {}, options?: AxiosRequestConfig) {
        return SupportApiFp(this.configuration).supportCreatePost(requestParameters.createAdminRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary SPD-5577: enters a facility as the built-in System user, or moves to another one. The  response is the token pair to continue with; the caller\'s current token is not changed.
     * @param {SupportApiSupportEnterFacilityFacilityIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public supportEnterFacilityFacilityIdPost(requestParameters: SupportApiSupportEnterFacilityFacilityIdPostRequest, options?: AxiosRequestConfig) {
        return SupportApiFp(this.configuration).supportEnterFacilityFacilityIdPost(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SupportApiSupportFacilitiesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public supportFacilitiesGet(requestParameters: SupportApiSupportFacilitiesGetRequest = {}, options?: AxiosRequestConfig) {
        return SupportApiFp(this.configuration).supportFacilitiesGet(requestParameters.filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SupportApiSupportFacilityGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public supportFacilityGet(requestParameters: SupportApiSupportFacilityGetRequest = {}, options?: AxiosRequestConfig) {
        return SupportApiFp(this.configuration).supportFacilityGet(requestParameters.filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary SPD-5577: the facilities a support user can enter, for the picker after sign-in and  the selector at the top of the portal.
     * @param {SupportApiSupportFacilityOptionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public supportFacilityOptionsGet(requestParameters: SupportApiSupportFacilityOptionsGetRequest = {}, options?: AxiosRequestConfig) {
        return SupportApiFp(this.configuration).supportFacilityOptionsGet(requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SupportApiSupportLoginFacilityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public supportLoginFacilityIdGet(requestParameters: SupportApiSupportLoginFacilityIdGetRequest, options?: AxiosRequestConfig) {
        return SupportApiFp(this.configuration).supportLoginFacilityIdGet(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }
}
